export default __webpack_public_path__ + "static/media/Enviar.a90f3017.svg";